import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const BalanceIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.27813 1.66318C5.46698 1.41138 5.76337 1.26318 6.07812 1.26318H18.0781C18.3929 1.26318 18.6893 1.41138 18.8781 1.66318L21.8781 5.66318C22.0079 5.83628 22.0781 6.04681 22.0781 6.26318V20.2632C22.0781 21.0588 21.7621 21.8219 21.1994 22.3845C20.6368 22.9471 19.8738 23.2632 19.0781 23.2632H5.07812C4.28247 23.2632 3.51941 22.9471 2.9568 22.3845C2.3942 21.8219 2.07812 21.0588 2.07812 20.2632V6.26318C2.07812 6.04681 2.1483 5.83628 2.27812 5.66318L5.27813 1.66318ZM6.57812 3.26318L4.07812 6.59652V20.2632C4.07812 20.5284 4.18348 20.7828 4.37102 20.9703C4.55855 21.1578 4.81291 21.2632 5.07812 21.2632H19.0781C19.3433 21.2632 19.5977 21.1578 19.7852 20.9703C19.9728 20.7828 20.0781 20.5284 20.0781 20.2632V6.59652L17.5781 3.26318H6.57812Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.07812 6.26318C2.07812 5.7109 2.52584 5.26318 3.07812 5.26318H21.0781C21.6304 5.26318 22.0781 5.7109 22.0781 6.26318C22.0781 6.81547 21.6304 7.26318 21.0781 7.26318H3.07812C2.52584 7.26318 2.07812 6.81547 2.07812 6.26318Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.07812 9.26318C8.63041 9.26318 9.07812 9.7109 9.07812 10.2632C9.07812 11.0588 9.3942 11.8219 9.9568 12.3845C10.5194 12.9471 11.2825 13.2632 12.0781 13.2632C12.8738 13.2632 13.6368 12.9471 14.1994 12.3845C14.7621 11.8219 15.0781 11.0588 15.0781 10.2632C15.0781 9.7109 15.5258 9.26318 16.0781 9.26318C16.6304 9.26318 17.0781 9.7109 17.0781 10.2632C17.0781 11.5893 16.5513 12.861 15.6137 13.7987C14.676 14.7364 13.4042 15.2632 12.0781 15.2632C10.752 15.2632 9.48027 14.7364 8.54259 13.7987C7.60491 12.861 7.07812 11.5893 7.07812 10.2632C7.07812 9.7109 7.52584 9.26318 8.07812 9.26318Z"
            fill={iconColor}
        />
    </svg>
);

export { BalanceIcon };